module.exports = __webpack_public_path__ + "static/media/energetic_sad.1945b8dd.svg";